import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Routing
import routes from '~/apiRouter';

// Metrika
import metrikaGoal from '~/helpers/metrikaGoal';

// Components
import Loader from '~/components/ui/Loader';
import PopupClose from '~/components/popups/Close';
import CoursePlaybillFilter from '~/components/playbill/CourseFilter';
import CoursePlaybillContent from '~/components/playbill/CourseContent';
import CoursePlaybillAside from '~/components/playbill/CourseAside';

// Config and data
import { onlineCityCode } from '~/data/fakeCities'; // its not fake, its real
import { getCityKLADRByName } from '~h/cityCodes';
import filters from '~/data/coursePlaybillFilters';

import { filterAvailableOnlineEvents } from '~h/eventFilters';

export default class CoursePlaybill extends Component {
  state = {
    data: [],
    filteredData: [],
    filter: [],
    discount: null,         // string | null
    oldDiscount: null,      // string | null
    discounts: null,        // Array<{...}> | null
    discountHeader: null,   // string | null
    loading: true,
    error: null,
  };

  componentDidMount() {
    metrikaGoal('reg-open-popup');
    metrikaGoal('scenario-search-open-popup');
    metrikaGoal('scenario-menu-open-popup');
    metrikaGoal('scenario-slider-open-popup');
    metrikaGoal('scenario-playbill-open-popup');

    this.loadData();
  }

  prepareData(data) {
    const cards = [];
    data = data.filter(
      c => c.SHORT_NAME && (c.CITY_CODE == onlineCityCode || c.CITY != null),
    );
    data.forEach(c => {
      if (c.START_DATE) {
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date(c.START_DATE),
          productCard: false,
          ...c,
        });
      } else {
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date(),
          productCard: true,
          ...c,
        });
      }
    });

    cards.sort((a, b) => {
      if (!(a.DISCIPLINE_CONNECTOR_SORT - b.DISCIPLINE_CONNECTOR_SORT)) {
        return a.dateFrom - b.dateFrom;
      } else return a.DISCIPLINE_CONNECTOR_SORT - b.DISCIPLINE_CONNECTOR_SORT;
    });

    // Send online-courses to bottom of list
    cards.sort((a, b) => {
      if (a.CITY_CODE == onlineCityCode && b.CITY_CODE != onlineCityCode) {
        return 1;
      }
      if (a.CITY_CODE != onlineCityCode && b.CITY_CODE == onlineCityCode) {
        return -1;
      }
      return 0;
    });

    return cards;
  }

  prepareFilter(data) {
    const city = this.props.city
      ? Object.values(window.city).find(city => city.ID == this.props.city.id)
      : Object.values(window.city).find(city => city.CURRENT);
    const newFilters = filters;

    if (city?.NAME)
      newFilters.find(filter => filter.name === 'cities').value = city.NAME;

    return newFilters;
  }

  loadData() {
    const { code } = this.props;
    if (!code) {
      this.setState({
        data: [],
        filteredData: [],
        filter: [],
        discount: null,
        loading: false,
      });
      return;
    }

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    headers.credentials = 'include';
    const pageCode = this.props.pageCode ? `/page/${this.props.pageCode}` : '';
    const url = `${routes.playbill.get}${this.props.code}${pageCode}`;
    fetch(url, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          // TODO: Need to refactor
          const filter = this.prepareFilter(response.data.EVENTS);
          const newData = this.prepareData(response.data.EVENTS);

          this.setState({
            data: newData || [],
            filteredData: this.filterData(filter, newData) || [],
            filter: filter || [],
            discount: this.filterDiscount(filter, response.data.DISCOUNT_CUSTOM, response.data.DISCOUNT, response.data.DISCOUNT_HEADER) || null,
            oldDiscount: response.data.DISCOUNT || null,
            discountHeader: response.data.DISCOUNT_HEADER || null,
            discounts: response.data.DISCOUNT_CUSTOM || null,
            loading: false,
          });
        } else {
          this.setState({
            error: response.errors || ['Ошибка загрузки данных расписания'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки расписания с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  filterData(filter, newData = null) {
    const { data } = this.state;
    const filteredData = [];
    if (newData == null) newData = data;

    const cities = filter.filter(f => f.name === 'cities')[0].value;
    newData.forEach(c => {
      if (
        ((c.CITY && (c.CITY.NAME === cities || c.CITY.NAME === 'Москва')) ||
          c.CITY_CODE == onlineCityCode) &&
        (new Date(c.START_DATE).getTime() > Date.now() || c.productCard)
      )
      {
        filteredData.push(c);
      }
    });

    return filterAvailableOnlineEvents(
      filteredData,
      getCityKLADRByName(
        filter.find(currentFilter => currentFilter.name === 'cities').value,
      ),
    );
  }

  // дает скидки (HTML строку) по discounts исходя из выбранного города
  filterDiscount(filter, _discounts = null, _oldDiscount = null, _discountHeader = null) {
    let discounts = _discounts || this.state.discounts;
    const oldDiscount = _oldDiscount || this.state.oldDiscount;
    const discountHeader = _discountHeader || this.state.discountHeader || '';
    if (!discounts) {
      if (!oldDiscount) return null;
      return oldDiscount;
    }
    discounts = discounts.filter(disc => !!disc.DISCOUNT_TEXT);
    if (!discounts.length) return oldDiscount;  // DISCOUNT || null

    function discountHTMLWrapper(text, title = null) {
      return `
            <div class="popup-info__blocks_discount">
              ${title ? `<h2><b>${title}</b></h2>` : ''}
              <div>${text}</div>
            </div>
          `;
    }

    // скидки, для которых не указаны KLADR городов, или только 7102000200000 (online)
    const commonDiscounts = discounts
      .filter(
        disc => disc.AVAILABILITY_IN_CITIES &&
          (disc.AVAILABILITY_IN_CITIES.length === 0 ||
            (disc.AVAILABILITY_IN_CITIES.length === 1 && disc.AVAILABILITY_IN_CITIES[0] === (onlineCityCode || '7102000200000'))),
      ).map(disc => discountHTMLWrapper(disc.DISCOUNT_TEXT, disc.DISCOUNT_TITLE)).join('');

    // скидки, для которых указан KLADR (не [7102000200000])
    const currentCityKLADR = getCityKLADRByName(filter[0].value);
    const currentCityDiscounts = currentCityKLADR !== (onlineCityCode || '7102000200000')
      ? discounts
        .filter(
          disc => disc.AVAILABILITY_IN_CITIES && disc.AVAILABILITY_IN_CITIES.indexOf(currentCityKLADR) !== -1,
        ).map(disc => discountHTMLWrapper(disc.DISCOUNT_TEXT, disc.DISCOUNT_TITLE)).join('')
      : '';

    // скидки без указания .DISCOUNT_TITLE
    const withoutTitleDiscounts = discounts
      .filter(
        disc => !disc.DISCOUNT_TITLE,
      ).map(disc => discountHTMLWrapper(disc.DISCOUNT_TEXT)).join('');

    return `
      <h1><b>${discountHeader}</b></h1>
      <div>${currentCityDiscounts}${commonDiscounts}${withoutTitleDiscounts}</div>
    `;
  }

  changeFilter(name, val) {
    const { filter } = this.state;
    const newFilter = filter.map(f => {
      if (f.name == name) f.value = val?.[0] || val;
      return f;
    });

    this.setState({
      filter: newFilter,
      filteredData: this.filterData(newFilter),
      discount: this.filterDiscount(newFilter),
    });
  }

  getHeading() {
    const { data } = this.state;
    const eventWithName = data.find(event => !!event.EVENT_PAGE.NAME);
    return eventWithName ? eventWithName.EVENT_PAGE.NAME : 'Расписание';
  }

  render() {
    const { data, filter, filteredData, loading, error, discount } = this.state;

    let heading = this.getHeading();
    if ($('.banner-top .heading--1:eq(0) span').length > 0) {
      heading = $('.banner-top .heading--1:eq(0) span').html();
    }

    if (loading) {
      return (
        <div className="popup popup-info popup-course-reg">
          <div className="popup-info__content">
            <div className="popup__close-container"><PopupClose/></div>
            <Loader/>
          </div>
        </div>
      );
    }

    const city = filters.find(filter => filter.name === 'cities').value;

    if (error) {
      // TODO: почистить лишнюю семантику
      const errors = error.map((e, index) => {
        return (
          <p key={`err_${index}`} className="txt txt--center txt--red">
            Ошибка получения данных от сервера.
          </p>
        );
      });
      return (
        <div className="popup popup-info popup-course-reg">
          <div className="popup-info__content">
            <div className="popup__close-container"><PopupClose/></div>
            {errors}</div>
        </div>
      );
    }

    return (
      <div className="popup popup-info popup-course-reg">
        <div className="popup-info__content">
          <div className="popup__close-container"><PopupClose/></div>
          <h4 className="heading heading--2">{heading}</h4>
          <div className="subheader">
            <CoursePlaybillFilter
              filters={filter}
              onChange={(name, val) => this.changeFilter(name, val)}
            />
            <div className="discount-container">
              <CoursePlaybillAside text={discount}/>
            </div>
          </div>
          <div className="popup-info__content--with-discount">
            <CoursePlaybillContent city={city} data={filteredData}/>
          </div>
        </div>
      </div>
    );
  }
}
